import { Card, Col, Space, Alert } from "antd"
import {
  FireOutlined,
} from "@ant-design/icons"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsMore from "highcharts/highcharts-more"
import HighchartsHeatmap from "highcharts/modules/heatmap"

// Initialize Highcharts modules
HighchartsMore(Highcharts)
HighchartsHeatmap(Highcharts)

const ResourceBurnMap = () => {

  const heatmapChart = {
    chart: { type: "heatmap", height: 300 },
    title: { text: "Resource Burn Map" },
    xAxis: { categories: ["Legal", "Finance", "Operations", "Strategy", "IT", "HR"] },
    yAxis: { categories: ["Overloaded", "Optimal", "Underutilized"], title: null },
    colorAxis: {
      min: 0,
      max: 100,
      stops: [
        [0, "#3060cf"],
        [0.5, "#fffbbc"],
        [1, "#c4463a"],
      ],
    },
    series: [
      {
        name: "Resource Utilization",
        borderWidth: 1,
        data: [
          [0, 0, 85],
          [1, 0, 45],
          [2, 0, 25],
          [3, 0, 70],
          [4, 0, 55],
          [5, 0, 30],
          [0, 1, 10],
          [1, 1, 40],
          [2, 1, 60],
          [3, 1, 25],
          [4, 1, 35],
          [5, 1, 50],
          [0, 2, 5],
          [1, 2, 15],
          [2, 2, 15],
          [3, 2, 5],
          [4, 2, 10],
          [5, 2, 20],
        ],
        dataLabels: { enabled: true, color: "#000000" },
      },
    ],
  }

  return (
    <Col xs={24} lg={12}>
          <Card
            title={
              <Space>
                <FireOutlined style={{ color: "#fa541c" }} />
                <span>Resource Burn Map</span>
              </Space>
            }
            style={{ height: "600px" }}
          >
            <Alert
              message="Ops load imbalance detected"
              description="Legal blocking 28% of risk plans, but Ops is 40% underutilized."
              type="warning"
              showIcon
              style={{ marginBottom: "16px" }}
            />
            <HighchartsReact highcharts={Highcharts} options={heatmapChart} />
          </Card>
        </Col>
  )
}

export default ResourceBurnMap